module.exports = __webpack_public_path__ + "img/Woman-4.845e7afc.svg";